enum FeeType {
    Percentage = 1,
    Fixed,
}

export default FeeType;
